import React, { useReducer, useState, useContext } from 'react';
import api from './ApiCall';
import { BATCH_LIST, BATCH_DETAILS, BatchContext, CommonContext } from './../constant/ActionTypes';
import { batchReducer } from './../reducer/batchReducer';
import Loader from './../../common/Loader/Loader';

const initialState = {
    batchList: [],
    batchDetails: {}
}

const BatchProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [batchState, dispatch] = useReducer(batchReducer, initialState);

    const [showLoader, setShowLoader] = useState(false);

    const getBatchList = (page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`BatchService/getAll${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: BATCH_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearBatchList = () => {
        dispatch({
            type: BATCH_LIST,
            payload: []
        });
    }
    
    const clearBatchDetails = () => {
        dispatch({
            type: BATCH_DETAILS,
            payload: {}
        });
    }

    const getBatchDetails = (id) => {
        api({ contentType: true, auth: true }).get(`BatchService/getDetails/${id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: BATCH_DETAILS,
                    payload: response.data.result
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const addBatchDetails = (data) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).post('BatchService/add', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getBatchList(1, 25);
                commonContext.handleSnackbar(true, 'success', 'Batch added successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Batch cannot be added');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Batch cannot be added');
            }
        });
    }

    const updateBatchDetails = (data) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch('BatchService/update', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getBatchList(1, 25);
                commonContext.handleSnackbar(true, 'success', 'Batch updated successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Batch cannot be updated');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Batch cannot be updated');
            }
        });
    }

    const deleteBatch = (batchId) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch(`BatchService/delete/${batchId}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getBatchList(1, 25);
                commonContext.handleSnackbar(true, 'success', 'Batch deleted successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Batch cannot be deleted');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Batch cannot be deleted');
            }
        });
    }

    return (
        <BatchContext.Provider
            value={{
                ...batchState,
                getBatchList: getBatchList,
                getBatchDetails: getBatchDetails,
                clearBatchDetails: clearBatchDetails,
                deleteBatch: deleteBatch,
                updateBatchDetails: updateBatchDetails,
                addBatchDetails: addBatchDetails,
                clearBatchList: clearBatchList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </BatchContext.Provider>
    );
}

export default BatchProvider;



// WEBPACK FOOTER //
// ./contexts/provider/BatchContext.js